import { ConsoleRequest, DataProviderType } from '../../../../utils/request';
import { GzSingleSelectComplexBaseDataProvider } from '../GzSingleSelectComplexBaseDataProvider';
import { GetItemsRequest, GetItemsResponse } from '../../types';

interface PoliciesResponse {
  data: Array<PolicyForFilter>;
  total: number;
}

interface PolicyForFilter {
  _id: string;
  name: string;
  default: boolean;
}

export class PolicyFilterDataProvider extends GzSingleSelectComplexBaseDataProvider {
  async getInitialItems(request: GetItemsRequest): Promise<GetItemsResponse | undefined> {
    try {
      const includedPolicyFilter = request.value ? [request.value] : [];

      const response = await ConsoleRequest.createRequest<PoliciesResponse>({
        dataProviderType: DataProviderType.CORE,
        endpoint: 'PolicyTemplates',
        method: 'nameFilterRecords',
        payload: {
          page: request.page,
          limit: request.limit,
          name: request.searchValue,
          includeDefaultPolicy: true,
          includePolicies: includedPolicyFilter,
        },
      });

      const policiesItems = this.removeDuplicatePolicies(response.data);

      return {
        items: policiesItems.map(policy => ({ value: policy._id, label: policy.name })),
        totalItemsCount: response.total,
      };
    } catch (e) {
      throw new Error(e);
    }
  }

  async getItems(request: GetItemsRequest): Promise<GetItemsResponse | undefined> {
    try {
      const response = await ConsoleRequest.createRequest<PoliciesResponse>({
        dataProviderType: DataProviderType.CORE,
        endpoint: 'PolicyTemplates',
        method: 'nameFilterRecords',
        payload: {
          page: request.page,
          limit: request.limit,
          name: request.searchValue,
        },
      });
      return {
        items: response.data.map(policy => ({ value: policy._id, label: policy.name })),
        totalItemsCount: response.total,
      };
    } catch (e) {
      throw new Error(e);
    }
  }

  private removeDuplicatePolicies(policies: Array<PolicyForFilter>): Array<PolicyForFilter> {
    return policies.reduce((uniqPoliciesResult, currentPolicy) => {
      if (uniqPoliciesResult.find(policy => policy._id === currentPolicy._id)) {
        return uniqPoliciesResult;
      }

      return uniqPoliciesResult.concat(currentPolicy);
    }, [] as Array<PolicyForFilter>);
  }
}
